import React from "react"

import { List } from "./suggestionsListStyles"

export const SuggestionsList = ({ isCollapsed, isFullScreen, children }) => (
  <List $isCollapsed={isCollapsed} $isFullScreen={isFullScreen}>
    {children}
  </List>
)
